/*
 * @author bai <ghimping@alpstein.my>
 * @link https://www.alpstein.my
 * @copyright Copyright (c) Alpstein Software
 *            _____                    _____                    _____
 *           /\    \                  /\    \                  /\    \
 *          /::\    \                /::\    \                /::\    \
 *         /::::\    \              /::::\    \               \:::\    \
 *        /::::::\    \            /::::::\    \               \:::\    \
 *       /:::/\:::\    \          /:::/\:::\    \               \:::\    \
 *      /:::/__\:::\    \        /:::/__\:::\    \               \:::\    \
 *     /::::\   \:::\    \      /::::\   \:::\    \              /::::\    \
 *    /::::::\   \:::\    \    /::::::\   \:::\    \    ____    /::::::\    \
 *   /:::/\:::\   \:::\ ___\  /:::/\:::\   \:::\    \  /\   \  /:::/\:::\    \
 *  /:::/__\:::\   \:::|    |/:::/  \:::\   \:::\____\/::\   \/:::/  \:::\____\
 *  \:::\   \:::\  /:::|____|\::/    \:::\  /:::/    /\:::\  /:::/    \::/    /
 *   \:::\   \:::\/:::/    /  \/____/ \:::\/:::/    /  \:::\/:::/    / \/____/
 *    \:::\   \::::::/    /            \::::::/    /    \::::::/    /
 *     \:::\   \::::/    /              \::::/    /      \::::/____/
 *      \:::\  /:::/    /               /:::/    /        \:::\    \
 *       \:::\/:::/    /               /:::/    /          \:::\    \
 *        \::::::/    /               /:::/    /            \:::\    \
 *         \::::/    /               /:::/    /              \:::\____\
 *          \::/____/                \::/    /                \::/    /
 *           ~~                       \/____/                  \/____/
 *
 */

import React, { Component } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { intl } from "../../services/intlGlobalProvider";
import { FaLink } from "react-icons/fa";
import { connect } from "react-redux";
import {
  FacebookShareButton,
  FacebookIcon,
  WhatsappShareButton,
  WhatsappIcon,
  TwitterShareButton,
  TwitterIcon,
  GooglePlusShareButton,
  GooglePlusIcon,
  EmailShareButton,
  EmailIcon,
  TelegramShareButton,
  TelegramIcon
} from "react-share";
import * as meSelectors from "../../selectors/me";
import * as selectors from "../../selectors";
import * as meAction from "../../actions/me";
import LoadingIndicator from "../../components/LoadingIndicator";
import Toast from "../../utils/Toast";
import Theme from "../../utils/Theme";
import "./index.css";

const StyledContainer = styled.div`
  width: 100%;
  display: flex;
  overflow-x: hidden;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
`;

const StyledTopContainer = styled.div`
  width: 100%;
  background: white;
  display: flex;
  overflow-x: hidden;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
`;

const StyledTopContentContainer = styled.div`
  color: grey;
  width: 85%;
  display: flex;
  overflow-x: hidden;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
`;

const StyledImage = styled.img`
  margin-top: 25px;
  width: 25%;
  heigh: auto;
`;

const StyledContentDescription = styled.span`
  line-height: 1.5em;
  font-size: 1em;
`;

const StyledShareTitle = styled.span`
  margin-top: 30px;
  color: ${Theme.SecondaryColor};
  font-size: 1.1em;
`;

const StyledShareButton = styled.div`
  position: relative;
  width: 70%;
  padding: 1.1em;
  margin-top: 20px;
  margin-bottom: 40px;
  cursor: pointer;
  border: 1px solid lightgray;
  background: #f4f4f4;
  color: red;
  font-size: 1.1em;
  font-weight: bold;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

const StyledBottomContainer = styled.div`
  width: 80%;
  display: flex;
  overflow-x: hidden;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
`;

const StyledBottomTitle = styled.span`
  margin-top: 30px;
  font-size: 1em;
  color: grey;
  line-height: 1.1em;
`;

const StyledSocialContainer = styled.div`
  margin-top: 20px;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

const StyledSocialIcon = styled.div`
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
`;

const StyledSocialTitle = styled.span`
  color: gray;
  font-size: 1em;
  margin-top: 10px;
`;

class InviteFriendsPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      branchLoading: false,
      animationClass: null,
      shareUrl: "https://lssquare.com/",
      shareTitle: intl.formatMessage({ id: "invite.friend.share.action.title" })
    };
  }

  componentDidMount() {
    const { userDetails } = this.props;

    this.configureNavBar();
    this.setState({ animationClass: "slide-in-right" });
    if (userDetails) {
      this.configureShareLink();
    } else {
      this.getUserProfile();
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.userDetails !== nextProps.userDetails) {
      this.configureShareLink();
    }
  }

  configureNavBar = () => {
    const { navbarConfig, showTabbar, showNavbar } = this.props;
    const navTitle = (
      <FormattedMessage
        id="invite.friends.title"
        defaultMessage="Invite Friends"
        description="Invite Friends Title"
      />
    );

    navbarConfig(navTitle, null, null, () => this.onBackPressed());
    showNavbar(true);
    showTabbar(false);
  };

  configureShareLink = () => {
    const { userDetails } = this.props;
    const userID = meSelectors.getMeID(userDetails);
    const username = meSelectors.getMeName(userDetails);
    const userReferrerCode = meSelectors.getMeReferrerCode(userDetails);
    const linkData = {
      data: {
        referrerUsername: username,
        referrerUserID: userID ? userID.toString() : null,
        referrerCode: userReferrerCode
      }
    };

    this.setState({ branchLoading: true });
    window.branch.link(linkData, (err, link) => {
      if (!err) {
        this.setState({ shareUrl: link });
      }
      this.setState({ branchLoading: false });
    });
  };

  getLoadingIndicator = () => {
    const { loading } = this.props;
    const { branchLoading } = this.state;

    return loading || branchLoading ? <LoadingIndicator /> : false;
  };

  onBackPressed = () => {
    const { history } = this.props;
    this.setState({ animationClass: "slide-out-right" });

    window.setTimeout(() => {
      history.goBack();
    }, 300);
  };

  onPressCopyToClipboard = () => {
    navigator.clipboard.writeText(this.state.shareUrl);
    Toast.info("Copied to Clipboard!");
  };

  getUserProfile = () => {
    const { getMeData } = this.props;

    getMeData && getMeData();
  };

  render() {
    const { animationClass, shareUrl, shareTitle } = this.state;
    const { userDetails } = this.props;
    const userReferrerCode = meSelectors.getMeReferrerCode(userDetails);

    return (
      <StyledContainer
        className={animationClass !== null ? animationClass : false}
        onAnimationEnd={() => this.setState({ animationClass: null })}
      >
        {this.getLoadingIndicator()}
        <StyledTopContainer>
          <StyledTopContentContainer>
            <StyledImage src={require("../../assets/icons/mail.png")} />
            <StyledContentDescription style={{ marginTop: "20px" }}>
              <FormattedMessage
                id="invite.friends.description"
                defaultMessage="Share the love by inviting our fiends to LS Square"
                description="Invite Friends Description"
              />
            </StyledContentDescription>
            <StyledContentDescription>
              <FormattedMessage
                id="invite.friends.min.value"
                defaultMessage="(min purchased of RM10)"
                description="Invite Friends Min Purchased Value"
              />
            </StyledContentDescription>
            <StyledShareTitle>
              <FormattedMessage
                id="invite.friends.share.title"
                defaultMessage="Share your referral code"
                description="Invite Friends Share Referral Code Title"
              />
            </StyledShareTitle>
            <StyledShareButton
              className={"underline opacity"}
              onClick={this.onPressCopyToClipboard}
            >
              {userReferrerCode}
              <FaLink
                size={"1.1em"}
                color={"grey"}
                style={{
                  position: "absolute",
                  right: 15,
                  transform: "rotate(225deg)"
                }}
              />
            </StyledShareButton>
          </StyledTopContentContainer>
        </StyledTopContainer>
        <StyledBottomContainer>
          <StyledBottomTitle>
            <FormattedMessage
              id="invite.friends.share.option.title"
              defaultMessage="Share to your friends by using there"
              description="Invite Friends Share Options Title"
            />
          </StyledBottomTitle>
          <StyledSocialContainer>
            <StyledSocialIcon>
              <FacebookShareButton
                className="social-btn opacity"
                style={{
                  background: "rgb(59, 89, 152)"
                }}
                url={shareUrl}
                quote={shareTitle}
              >
                <FacebookIcon size={"4em"} />
              </FacebookShareButton>
              <StyledSocialTitle>Facebook</StyledSocialTitle>
            </StyledSocialIcon>
            <StyledSocialIcon>
              <TwitterShareButton
                className="social-btn opacity"
                style={{
                  background: "rgb(0, 172, 237)"
                }}
                url={shareUrl}
                title={shareTitle}
              >
                <TwitterIcon size={"4em"} />
              </TwitterShareButton>
              <StyledSocialTitle>Twitter</StyledSocialTitle>
            </StyledSocialIcon>
            <StyledSocialIcon>
              <GooglePlusShareButton
                className="social-btn opacity"
                style={{
                  background: "rgb(221, 75, 57)"
                }}
                url={shareUrl}
              >
                <GooglePlusIcon size={"4em"} />
              </GooglePlusShareButton>
              <StyledSocialTitle>Google+</StyledSocialTitle>
            </StyledSocialIcon>
          </StyledSocialContainer>
          <StyledSocialContainer>
            <StyledSocialIcon>
              <TelegramShareButton
                className="social-btn opacity"
                style={{
                  background: "rgb(55, 174, 226)"
                }}
                url={shareUrl}
                title={shareTitle}
              >
                <TelegramIcon size={"4em"} />
              </TelegramShareButton>
              <StyledSocialTitle>Telegram</StyledSocialTitle>
            </StyledSocialIcon>
            <StyledSocialIcon>
              <WhatsappShareButton
                className="social-btn opacity"
                style={{
                  background: "rgb(44, 183, 66)"
                }}
                url={shareUrl}
                title={shareTitle}
              >
                <WhatsappIcon size={"4em"} />
              </WhatsappShareButton>
              <StyledSocialTitle>Whatsapp</StyledSocialTitle>
            </StyledSocialIcon>
            <StyledSocialIcon>
              <EmailShareButton
                className="social-btn opacity"
                style={{
                  background: "rgb(127, 127, 127)"
                }}
                url={shareUrl}
                subject={shareTitle}
              >
                <EmailIcon size={"4em"} />
              </EmailShareButton>
              <StyledSocialTitle>Email</StyledSocialTitle>
            </StyledSocialIcon>
          </StyledSocialContainer>
          <div style={{ marginTop: "20px" }} />
        </StyledBottomContainer>
      </StyledContainer>
    );
  }
}

InviteFriendsPage.propTypes = {
  showNavbar: PropTypes.func.isRequired,
  showTabbar: PropTypes.func.isRequired,
  navbarConfig: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  userDetails: PropTypes.object,
  getMeData: PropTypes.func,
  loading: PropTypes.bool
};

function mapStateToProps(state) {
  return {
    userDetails: selectors.getMeData(state),
    loading: selectors.getMeLoading(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getMeData: () => dispatch(meAction.getMeDataRequest())
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InviteFriendsPage);



// WEBPACK FOOTER //
// ./src/containers/InviteFriendsPage/index.js